import { Component, OnInit, Input, Inject } from '@angular/core';
import { UI_STATE } from '../../services/ui-state';

@Component({
    standalone: false,
    selector: 'help-text-content',
    templateUrl: './help-text-content.component.html',
    styleUrls: ['./help-text-content.component.css'],
})
export class HelpTextContentComponent implements OnInit {
    @Input() id!: string;
    public ui: any;

    constructor( @Inject(UI_STATE) ui: any) {
        this.ui = ui;
    }

    ngOnInit() {
    }

    onClose() {
        this.ui[this.id] = false;
    }
}
